import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        Ideal Training Acacdemy
      </header>
    </div>
  );
}

export default App;
